import React, { useState, useEffect } from 'react';
import { FaFileAlt } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import loadingspinner from '../../assets/images/loading2.gif'
import AlertMessage from '../../AlertMessage';

function Pavati() {
  const location = useLocation();
  const [selectedClass, setSelectedClass] = useState('');
  const [classOptions, setClassOptions] = useState([]);
  const [divisionOptions, setDivisionOptions] = useState([]);
  const [schoolDetails, setSchoolDetails] = useState({});
  const [serialNo, setSerialNo] = useState(null);
  const [classWiseAmounts, setClassWiseAmounts] = useState({});
  const [classes, setClasses] = useState([]);
  const [filteredFeeDetails, setFilteredFeeDetails] = useState({});
  const navigate = useNavigate();
  const [totalFee, setTotalFee] = useState(0);
  const [selectedYear, setSelectedYear] = useState('');
  const [selectedDivision, setSelectedDivision] = useState(" ");
  const [filteredStudents, setFilteredStudents] = useState([]);
  const udiseNumber = localStorage.getItem("udiseNumber");
  const [classCounts, setClassCounts] = useState({});
  const [students, setStudents] = useState([]);
  const [feePerClass, setFeePerClass] = useState({});
  const [selectedRegisterNo, setSelectedRegisterNo] = useState('');
  const [selectedFee, setSelectedFee] = useState('');
  const [readMoreVisible, setReadMoreVisible] = useState(false);
  const [rootData, setRootData] = useState('');
  const [root, setRoot] = useState([]);
  const [roots, setRoots] = useState([]);
  const [driver, setDriver] = useState('');
  const [dateFrom, setDateFrom] = useState(new Date().toISOString().split('T')[0]);
  const [dateTo, setDateTo] = useState(new Date().toISOString().split('T')[0]);
  const [drivers, setDrivers] = useState([]);
  const [allData, setAllData] = useState({})
  const [allData2, setAllData2] = useState({})
  const [selectedFeeType, setSelectedFeeType] = useState('');
  const [amount1, setAmount1] = useState('');
  const [studentSerialNo, setStudentSerialNo] = useState([]);
  const [fromtheway, setFromtheway] = useState('');
  const [allFeeTypes, setAllFeeTypes] = useState([]);
  const [filteredFeeTypes, setFilteredFeeTypes] = useState([]);
  const [thewayup, setThewayup] = useState('');
  const [feeData, setFeeData] = useState({});
  const [driverInfo, setDriverInfo] = useState(null);
  const language = localStorage.getItem("language");
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage("");
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);

  const sortClasses = (classes, language) => {
    const classOrder = {
      "Class I": 1,
      "Class II": 2,
      "Class III": 3,
      "Class IV": 4,
      "Class V": 5,
      "Class VI": 6,
      "Class VII": 7,
      "Class VIII": 8,
      "Class IX": 9,
      "Class X": 10,
      "Class XI": 11,
      "Class XII": 12,
      "इयत्ता पहिली": 1,
      "इयत्ता दुसरी": 2,
      "इयत्ता तिसरी": 3,
      "इयत्ता चौथी": 4,
      "इयत्ता पाचवी": 5,
      "इयत्ता सहावी": 6,
      "इयत्ता सातवी": 7,
      "इयत्ता आठवी": 8,
      "इयत्ता नववी": 9,
      "इयत्ता दहावी": 10,
      "इयत्ता अकरावी": 11,
      "इयत्ता बारावी": 12,
    };

    return classes.sort((a, b) => classOrder[a] - classOrder[b]);
  };


  const openIndexedDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1); // Use your actual DB name and version

      request.onerror = (event) => {
        console.error("IndexedDB error:", event.target.error);
        reject("Error opening IndexedDB");
      };

      request.onsuccess = (event) => {
        resolve(event.target.result);
      };

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('studentData')) {
          db.createObjectStore('studentData', { keyPath: 'id' });
        }
      };
    });
  };


  useEffect(() => {
    const fetchDefaultYear = async () => {
      try {
        const db = await openIndexedDB();
        const transaction = db.transaction(['defaultSettings'], 'readonly');
        const objectStore = transaction.objectStore('defaultSettings');
        const request = objectStore.get('defaultSettings');

        request.onsuccess = (event) => {
          const defaultSetting = event.target.result;

          if (defaultSetting) {
            setSelectedYear(defaultSetting.defaultYear);
          } else {
            console.warn("No default settings found for the key 'defaultSettings'.");
          }
        };

        request.onerror = (event) => {
          console.error("Error fetching default settings:", event.target.error);
        };
      } catch (error) {
        console.error('Error fetching default year:', error);
      }
    };
    fetchDefaultYear();
  }, [udiseNumber]);

  // Fetch class and division data from localStorage
  const fetchClassDivData = async () => {
    try {
      const storedDivClasses = localStorage.getItem("classDiv");
      if (storedDivClasses) {
        const data = JSON.parse(storedDivClasses);

        const classList = [];
        const divisionList = {};

        for (const [className, value] of Object.entries(data)) {
          if (value === true) {
            classList.push(className);
            divisionList[className] = [];
          } else if (typeof value === 'object') {
            classList.push(className);
            divisionList[className] = Object.keys(value).filter(div => value[div]); // Get divisions that are true
          }
        }

        setClasses(classList);
        setDivisionOptions(divisionList);
      }
    } catch (error) {
      console.error("Error fetching classDiv data: ", error);
    }
  };

  useEffect(() => {
    fetchClassDivData();
  }, [udiseNumber]);

  const fetchClassWiseFeeDetails = async (udiseNumber, selectedClass, selectedYear, selectedDivision) => {
    if (!selectedYear) {
      return {}; // Exit early if no year is selected
    }
    console.log(" selectedClass", selectedClass, " , ", "selectedYear", selectedYear, " , ", " selectedDivision", selectedDivision);

    setLoading(true);
    try {
      const feeUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentFee/${selectedYear}.json`;
      const response = await fetch(feeUrl);

      const feeUrl2 = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentFee.json`;
      const response2 = await fetch(feeUrl2);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      const data2 = await response2.json();
      console.log('Fetched data:', data);
      setAllData(data || {});  // Ensure data is at least an empty object
      setAllData2(data2 || {}); // Ensure data2 is at least an empty object

      // Check if data exists and is a valid object
      if (!data || typeof data !== 'object' || Object.keys(data).length === 0) {
        console.log('No valid data available');
        return {}; // Exit early if data is not valid
      }

      const filteredData = {};

      // Iterate through each serial number in the data
      for (const serialNo in data) {
        // Skip the lastInvoiceNo key as it's metadata
        if (serialNo === 'lastInvoiceNo') continue;

        const invoices = data[serialNo];

        // Check if invoices exists and is an object
        if (!invoices || typeof invoices !== 'object') {
          console.warn(`No invoices found for serialNo: ${serialNo}`);
          continue;
        }

        // Initialize filteredData for this serialNo
        let hasMatchingData = false;

        // Iterate through each invoice number
        for (const invoiceNo in invoices) {
          const studentFees = invoices[invoiceNo];

          // Check if studentFees exists and is an object
          if (!studentFees || typeof studentFees !== 'object') {
            console.warn(`No student fees found for serialNo: ${serialNo}, invoiceNo: ${invoiceNo}`);
            continue;
          }

          // Iterate through each fee key (fee type)
          for (const feeKey in studentFees) {
            const studentFee = studentFees[feeKey];

            // Check if studentFee exists and has required properties
            if (!studentFee || typeof studentFee !== 'object') {
              console.warn(`Invalid student fee data for serialNo: ${serialNo}, invoiceNo: ${invoiceNo}, feeKey: ${feeKey}`);
              continue;
            }

            // Safely extract fee details with fallbacks
            const feeClass = studentFee.class || studentFee.currentClass || '';
            const feeYear = studentFee.year || studentFee.educationalYear || '';
            const feeDivision = studentFee.division || '';

            // Apply filters with proper type checking
            const isClassMatch = selectedClass === "All" ||
              (feeClass && feeClass.toString() === selectedClass.toString());
            const isYearMatch = selectedYear === "" ||
              (feeYear && feeYear.toString() === selectedYear.toString());
            const isDivisionMatch = selectedDivision === "All" ||
              (feeDivision && feeDivision.toString() === selectedDivision.toString());

            // If all conditions match, add to filtered data
            if (isClassMatch && isYearMatch && isDivisionMatch) {
              // Initialize nested objects if they don't exist
              if (!filteredData[serialNo]) {
                filteredData[serialNo] = {};
              }
              if (!filteredData[serialNo][invoiceNo]) {
                filteredData[serialNo][invoiceNo] = {};
              }

              filteredData[serialNo][invoiceNo][feeKey] = studentFee;
              hasMatchingData = true;
            }
          }
        }

        // Remove serialNo from filteredData if no matching data was found
        if (!hasMatchingData && filteredData[serialNo]) {
          delete filteredData[serialNo];
        }
      }

      console.log('Filtered data:', filteredData);
      return filteredData;

    } catch (error) {
      console.error('Error fetching fee details:', error);
      return {}; // Return empty object on error
    } finally {
      setLoading(false); // Set loading to false after fetching data
    }
  };

  useEffect(() => {

    fetchClassWiseFeeDetails(udiseNumber, selectedClass, selectedYear, selectedDivision)
      .then(feeDetails => {
        console.log(" selectedClass", selectedClass, " , ", "selectedYear", selectedYear, " , ", " selectedDivision", selectedDivision);

        console.log('Fetched fee details 136 :', feeDetails);
        setFilteredFeeDetails(feeDetails);
      })
      .catch(error => console.error('Error updating fee details:', error));
  }, [selectedClass, selectedYear, selectedDivision, udiseNumber]);



  const handleIconClick = () => {
    // Check if there are filtered fee details before navigating
    if (Object.keys(filteredFeeDetails).length > 0) {
      // Navigate to /pavatino1 and pass the relevant data in state
      navigate('/pavatino1', {
        state: {
          serialNo: serialNo || 'N/A',
          year: selectedYear || 'N/A',
          selectedClass: selectedClass || 'N/A',
          division: selectedDivision || 'N/A', // Pass selected division
          schoolDetails,
          feeDetails: filteredFeeDetails, // Pass filtered fee details
          selectedFee: selectedFee || 'N/A', // Pass selected fee
        }
      });
    } else {
      // If no fee details are available, show a warning
      console.warn('No fee details available to navigate');
      setAlertMessage('No fee details found for the selected criteria.');
    }
  };



  const handleYearChange = (e) => {
    const selectedYear = e.target.value;
    setSelectedYear(selectedYear);
  };

  const handleDivisionChange = (e) => {
    if (selectedClass !== "All") {
      const selectedDivision = e.target.value;
      setSelectedDivision(selectedDivision);
    }
    localStorage.setItem("selectedDivision", e.target.value);
    console.log('Selected Division:', selectedDivision);
  };

  useEffect(() => {
    const storedClass = localStorage.getItem("selectedClass");
    const storedDivision = localStorage.getItem("selectedDivision");

    if (storedClass) {
      setSelectedClass(storedClass); // Set the stored value to selectedClass state
    }

    if (storedDivision) {
      setSelectedDivision(storedDivision); // Set the stored value to selectedDivision state
    }
  }, []);

  const handleSelectChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedFee(selectedValue); // Update state with selected fee
    console.log("Selected Fee:", selectedValue); // Log the selected value
  };

  const fetchSchoolDetails = async (udiseNumber) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/schoolData.json`);
      const data = await response.json();

      return data || {}; // Return the fetched data or an empty object if null
    } catch (error) {
      console.error('Error fetching school details:', error);
      return {};
    }
  };




  useEffect(() => {

    if (location.state && location.state.classType) {
      setSelectedClass(location.state.classType);
    }
    if (location.state && location.state.serialNo) {
      setSerialNo(location.state.serialNo);
    }
  }, [location.state, udiseNumber]);

  useEffect(() => {
    const fetchSchoolData = async () => {
      if (udiseNumber) {
        const details = await fetchSchoolDetails(udiseNumber);
        setSchoolDetails(details);
      }
    };

    fetchSchoolData();
  }, [udiseNumber]);

  const getStudentCount = () => {
    return students.filter(student => {
      const isClassMatch = selectedClass === "All" || student.currentClass === selectedClass;
      const isDivisionMatch = selectedDivision === "All" || student.division === selectedDivision;
      return isClassMatch && isDivisionMatch;
    }).length;
  };

  // npmstart
  const fetchData = async () => {
    const studentUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData.json`;
    const feeUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/fees/${selectedYear}.json`;

    try {
      const [studentResponse, feeResponse] = await Promise.all([fetch(studentUrl), fetch(feeUrl)]);

      if (!studentResponse.ok || !feeResponse.ok) {
        throw new Error('Failed to fetch data');
      }

      let studentData = await studentResponse.json();
      let feeData = await feeResponse.json();


      studentData = studentData ? Object.fromEntries(Object.entries(studentData).filter(([key, value]) => value !== null)) : {};
      feeData = feeData ? Object.fromEntries(Object.entries(feeData).filter(([key, value]) => value !== null)) : {};

      const studentArray = Object.keys(studentData).map((key) => ({
        registerNo: key,
        ...studentData[key],
      }));

      const processedStudentArray = studentArray.map((student) => ({
        ...student,
        currentClass: student.currentClass || 'Unknown',
      }));

      // Filter students based on isActive field
      let filteredStudents = processedStudentArray.filter(student =>
        student.isActive === true || student.isActive === undefined
      );


      // Filter by class
      if (selectedClass && selectedClass !== 'All' && selectedClass !== 'Unknown') {
        filteredStudents = filteredStudents.filter((student) => student.currentClass === selectedClass);
      } else if (selectedClass === 'Unknown') {
        filteredStudents = filteredStudents.filter((student) => student.currentClass === 'Unknown');
      }

      if (selectedRegisterNo) {
        filteredStudents = filteredStudents.filter((student) => student.registerNo === selectedRegisterNo.trim());
      }

      const feeArray = Object.keys(feeData).map((key) => ({
        id: key,
        ...feeData[key],
      }));

      const combinedData = filteredStudents.map((student) => {
        const fee = feeArray.find((f) => f.feetype === student.feetype);
        return {
          ...student,
          amount: fee ? fee.amount : 'Not Available',
          feetype: fee ? fee.feetype : '',
          schoolBus: fee ? fee.schoolBus : false,
          currentClass: student.currentClass || '',
        };
      });

      // Calculate student count by class
      const studentCountByClass = filteredStudents.reduce((acc, student) => {
        acc[student.currentClass] = (acc[student.currentClass] || 0) + 1;
        return acc;
      }, {});
      studentCountByClass['All'] = studentArray.length;

      // Calculate total fee per class
      const feePerClass = combinedData.reduce((acc, student) => {
        const className = student.currentClass || 'Unknown';
        acc[className] = (acc[className] || 0) + Number(student.amount);
        return acc;
      }, {});

      const classWiseAmounts = feeArray.reduce((acc, fee) => {
        const className = fee.classType || 'Unknown';
        acc[className] = (acc[className] || 0) + Number(fee.amount);
        return acc;
      }, {});

      const totalFee = Object.values(classWiseAmounts).reduce((acc, amount) => acc + amount, 0);

      // Set state
      setStudents(studentArray);
      setClassCounts(studentCountByClass);
      console.log(studentCountByClass, "studentCountByClass");

      setFilteredStudents(combinedData);
      // setClasses([...new Set(studentArray.map((student) => student.currentClass))]);
      setTotalFee(totalFee);
      setFeePerClass(feePerClass);
      setClassWiseAmounts(classWiseAmounts);

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };


  useEffect(() => {
    fetchData();
  }, [udiseNumber, selectedClass, selectedYear]);

  const handlePdfClick = async () => {
    // console.log("Filtered Fee Details:", filteredFeeDetails);
    // console.log("Year:", selectedYear);
    // console.log("Selected Class:", selectedClass);
    // console.log("Selected Division:", selectedDivision);
    // console.log("School Details:", schoolDetails);
    // console.log("Selected Fee:", selectedFee);

    const studentUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData.json`;
    const studentResponse = await fetch(studentUrl);
    const studentData = await studentResponse.json();

    // console.log("studentData", studentData);

    let studentsInClass;
    if (selectedClass === "All") {
      studentsInClass = Object.values(studentData || {}).filter(
        (student) => student !== null && student.educationalYear === selectedYear
      );
    } else {
      // Filter students based on selected class
      studentsInClass = Object.values(studentData || {}).filter(
        (student) => student !== null && student.currentClass === selectedClass && student.educationalYear === selectedYear
      );
    }

    const totalStudentCount = studentsInClass.length;

    console.log("Total Student Count:", totalStudentCount);

    if (Object.keys(filteredFeeDetails).length > 0 || (selectedClass === "All" && selectedDivision === "All")) {
      // Navigate to the Pavatino route and pass the appropriate data
      navigate('/pavatino', {
        state: {
          serialNo: serialNo || 'N/A',
          year: selectedYear || 'N/A',
          selectedClass: selectedClass || 'N/A',
          division: selectedDivision || 'N/A',
          schoolDetails,
          feeDetails: filteredFeeDetails,
          selectedFee: selectedFee || 'N/A',
          totalStudentCount: getStudentCount(), // Pass totalStudentCount
        }
      });
    } else {
      console.warn('No fee details available to navigate');
      setAlertMessage('No fee details found for the selected criteria.');
    }
  };




  const handleReadMoreClick = () => {
    setReadMoreVisible(!readMoreVisible); // Toggle the visibility of the small form
  };

  const fetchFeeTypes = async () => {
    const feeUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/fees/${selectedYear}.json`;

    try {
      const response = await fetch(feeUrl);
      if (!response.ok) {
        throw new Error('Failed to fetch fee types');
      }

      const feeData = await response.json();
      // console.log("Fetched Fee Data:", feeData); // Log fetched data for debugging
      setFeeData(feeData);
      // console.log("feeData",feeData);

      const feeTypesArray = feeData ? Object.keys(feeData) : [];
      setAllFeeTypes(feeTypesArray);
      // console.log("feeTypesArray",feeTypesArray);

      setFilteredFeeTypes(feeTypesArray); // Initially set filtered fee types to all
    } catch (error) {
      console.error('Error fetching fee types:', error);
    }
  };

  useEffect(() => {
    fetchFeeTypes();
  }, [udiseNumber, selectedYear]);

  useEffect(() => {
    // Function to filter fee types based on the currently selected class
    const filterFeeTypes = (selectedClass) => {
      let filtered = [];

      if (selectedClass === "All") {
        // If "All" is selected, show fee types set for "All"
        filtered = allFeeTypes.filter(feeType => {
          const feeClass = feeData[feeType]?.classType;
          return feeClass === "All"; // Adjust according to your data structure
        });
      } else if (selectedClass) {
        // Get fee types for the selected class
        filtered = allFeeTypes.filter(feeType => {
          const feeClass = feeData[feeType]?.classType;
          return feeClass == selectedClass; // Ensure matching class type
        });

        // Include fee types that are also associated with "All"
        const allClassFees = allFeeTypes.filter(feeType => {
          return feeData[feeType]?.classType === "All"; // Adjust if necessary
        });
        // console.log("allClassFees",allClassFees);

        filtered = [...filtered, ...allClassFees]; // Combine filtered with "All" class fee types
      } else {
        // If no class is selected, reset to all fee types
        filtered = allFeeTypes;
      }
      // console.log("filtered",filtered);

      setFilteredFeeTypes(filtered);
    };

    // Filter fee types when component mounts or when fee data or selected class changes
    filterFeeTypes(selectedClass);
  }, [selectedClass, feeData]); // Add feeData to dependencies if it can change

  const handleClassChange = (event) => {
    const selected = event.target.value;
    setSelectedClass(selected);
    localStorage.setItem("selectedClass", selected);

    if (selected === "All") {
      setSelectedDivision("All");
      document.getElementById("division").disabled = true;
    } else {
      document.getElementById("division").disabled = false;
    }
    // console.log("Selected Class:", selected);
  };

  useEffect(() => {
    const storedClass = localStorage.getItem("selectedClass");
    if (storedClass) {
      setSelectedClass(storedClass); // Set the stored value to selectedClass state
    }
  }, []);


  const handleFeeTypeChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedFeeType(selectedValue);
    // console.log("Selected Fee Type (onChange):", selectedValue); // Debugging the selection
  };



  const fetchDataroot1 = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/root/${selectedYear}.json`);
      const fetchedData = response.data;

      if (fetchedData) {
        // Convert the object to an array of objects
        const dataArray = Object.keys(fetchedData).map((key) => ({
          id: key,
          fromtheway: fetchedData[key].fromtheway,
          thewayup: fetchedData[key].thewayup,
        }));

        // Update the state with the fetched data
        setRoots(dataArray);
      } else {
        setRoots([]); // Clear data if no data found
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    fetchDataroot1();
  }, [udiseNumber, selectedYear]);

  useEffect(() => {
    // Fetch existing drivers when the component mounts
    const fetchDrivers = async () => {
      try {
        const driversResponse = await axios.get(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/drivers.json`);
        const driversData = driversResponse.data;


        // If there is driver data, convert it to an array of driver objects
        if (driversData) {
          const driverList = Object.values(driversData) // Convert object to array of driver objects
            .filter(driverItem => driverItem.driverName && driverItem.driverName.trim() !== ''); // Filter out invalid names
          setDrivers(driverList);
          // console.log(driverList, "driverList");
        } else {
          setDrivers([]);
        }
      } catch (error) {
        console.error('Error fetching driver data:', error);
      }
    };

    fetchDrivers();
  }, [udiseNumber]);



  const handleYearPdfClick = () => {
    // Check if both dates are selected
    if (!dateFrom || !dateTo) {
      alert('Please select both the start and end dates.');
      return; // Stop further execution if dates are missing
    }

    // Parse date strings
    const fromDate = new Date(dateFrom);
    const toDate = new Date(dateTo);

    let filteredFeeDetails = [];
    const studentsInRange = new Set(); // Track students with invoices in the date range

    // First pass: Find students who have invoices in the date range
    for (const year in allData2) {
      if (allData2.hasOwnProperty(year)) {
        const yearData = allData2[year];

        for (const serialNo in yearData) {
          if (yearData.hasOwnProperty(serialNo)) {
            const invoices = yearData[serialNo];

            for (const invoiceNo in invoices) {
              if (invoices.hasOwnProperty(invoiceNo)) {
                const feeTypes = invoices[invoiceNo];

                for (const feeType in feeTypes) {
                  if (feeTypes.hasOwnProperty(feeType)) {
                    const feeDetail = feeTypes[feeType];
                    const feeDate = new Date(feeDetail.date);

                    if (feeDate >= fromDate && feeDate <= toDate) {
                      studentsInRange.add(serialNo);
                      break; // Found one invoice in range for this student
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    // Second pass: Collect ALL invoices for students in the range
    for (const year in allData2) {
      if (allData2.hasOwnProperty(year)) {
        const yearData = allData2[year];

        for (const serialNo in yearData) {
          if (yearData.hasOwnProperty(serialNo) && studentsInRange.has(serialNo)) {
            const invoices = yearData[serialNo];

            for (const invoiceNo in invoices) {
              if (invoices.hasOwnProperty(invoiceNo)) {
                const feeTypes = invoices[invoiceNo];

                for (const feeType in feeTypes) {
                  if (feeTypes.hasOwnProperty(feeType)) {
                    const feeDetail = feeTypes[feeType];

                    filteredFeeDetails.push({
                      ...feeDetail,
                      serialNo,
                      invoiceNo,
                      year,
                    });
                  }
                }
              }
            }
          }
        }
      }
    }

    if (filteredFeeDetails.length > 0) {
      console.log("filteredFeeDetails", filteredFeeDetails);

      navigate('/year', {
        state: {
          serialNo: serialNo || 'N/A',
          year: selectedYear || 'N/A',
          selectedClass: selectedClass || 'N/A',
          division: selectedDivision || 'N/A',
          schoolDetails,
          feeDetails: filteredFeeDetails, // Pass filtered fee details
          selectedFee: selectedFee || 'N/A',
          dateFrom, // Pass dateFrom to the Yearpavati component
          dateTo,   // Pass dateTo to the Yearpavati component
        },
      });
    } else {
      console.log('No fee details found within the selected date range.');
      setAlertMessage('No fee details found within the selected date range.');
    }
  };




  const fetchFeeDetails = async (serialNo) => {
    try {
      const feeUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentFee/${selectedYear}/${serialNo}.json`;
      const response = await fetch(feeUrl);
      const feeData = await response.json();
      // console.log("feeData", feeData); // Log fetched fee data

      if (feeData) {
        const invoiceNumbers = Object.keys(feeData).map(Number).sort((a, b) => b - a);
        const highestInvoiceNo = invoiceNumbers[0];

        const latestFeeData = feeData[highestInvoiceNo];


        if (latestFeeData) {
          const formattedFeeData = Object.keys(latestFeeData).map(feetype => ({
            feetype,
            ...latestFeeData[feetype],
          }));
          return formattedFeeData; // Ensure you're returning valid data
        } else {
          console.error('No fee data found for the highest invoice number');
          return []; // Return an empty array if no data is found
        }
      } else {
        console.error('No fee data found for the selected student');
        return [];
      }
    } catch (error) {
      console.error('Error fetching fee details:', error);
      return [];
    }
  };




  useEffect(() => {
    if (serialNo && udiseNumber) {
      fetchFeeDetails(serialNo);
    }
  }, [serialNo, selectedYear, udiseNumber]);




  const handlePavatino1Click = () => {
    if (selectedFeeType) {
      // console.log("selectedFeeType",selectedFeeType);
      // console.log("allData",allData);

      // Check if allData is an object and has keys
      if (Object.keys(allData).length > 0) {
        const feeDetails = [];

        // Iterate through each student entry in allData
        Object.entries(allData).forEach(([serialNo, invoices]) => {
          // Check if invoices is an object
          if (typeof invoices === 'object') {
            Object.entries(invoices).forEach(([invoiceNo, feeTypes]) => {
              // Skip if feeTypes is null
              if (feeTypes === null) return;

              // Check if feeTypes is an object
              if (typeof feeTypes === 'object') {
                // Ensure feeDetail is not null
                const feeDetail = feeTypes[selectedFeeType];

                // Ensure feeDetail exists and is not null or has an amount of '0'
                if (feeDetail && feeDetail.class == selectedClass && feeDetail.amount && feeDetail.amount != '0') {
                  feeDetails.push({
                    serialNo,
                    invoiceNo,
                    feeType: selectedFeeType,
                    ...feeDetail, // Spread the details into the object
                  });
                }
              }
            });
          }
        });

        if (feeDetails.length > 0) {
          navigate('/feepavati', {
            state: {
              serialNo: 'N/A',
              year: selectedYear || 'N/A',
              selectedClass: selectedClass || 'N/A',
              division: selectedDivision || 'N/A',
              schoolDetails,
              selectedFee: selectedFee || 'N/A',
              feeDetails // Pass all matching fee details
            },
          });
          // console.log("Navigating with feeDetails:", feeDetails);
        } else {
          navigate('/feepavati2', {
            state: {
              serialNo: 'N/A',
              year: selectedYear || 'N/A',
              selectedClass: selectedClass || 'N/A',
              division: selectedDivision || 'N/A',
              schoolDetails,
              selectedFeeType: selectedFeeType || 'N/A',
              feeDetails
            },
          });
          // console.log("Navigating with feeDetails:", feeDetails);
          // setAlertMessage("No fee details available for the selected fee type and class.");
        }
      } else {
        setAlertMessage("No fee details available.");
      }
    } else {
      setAlertMessage("Please select a fee type first!");
    }
  };

  const getBaseFeetype = (feetype) => {
    const lastIndex = feetype.lastIndexOf('-');
    return lastIndex !== -1 ? feetype.substring(0, lastIndex) : feetype; // Return the part before the last '-' or the whole feetype if '-' is not found
  };
  const [newrootdata, setnewrootdata] = useState('')

  const fetchRootDetails = async (selectedRootId) => {
    if (!selectedRootId) return;

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/root/${selectedYear}/${selectedRootId}.json`
      );
      const rootData = response.data;

      // console.log('Fetched Root Data:', rootData);  // Log the fetched root data to check the structure

      if (rootData) {
        setnewrootdata(rootData)
        // Check and set amount1
        if (rootData.amount1 !== undefined) {
          setAmount1(rootData.amount1);  // Set the amount1 if it exists
        } else {
          console.warn('amount1 not found in the response:', rootData);
          setAmount1('No amount1 data');  // Fallback message if amount1 is missing
        }
        // console.log("rootData",rootData);

        // Set student serial numbers
        setStudentSerialNo(Object.keys(rootData.studentSerialNo || {})); // Ensure it's an object

        // Set fromtheway and thewayup
        setFromtheway(rootData.fromtheway || 'No data');  // Set fromtheway or fallback if missing
        setThewayup(rootData.thewayup || 'No data');      // Set thewayup or fallback if missing
      } else {
        // Clear values if no data
        setAmount1('');
        setStudentSerialNo([]);
        setFromtheway('');
        setThewayup('');
      }
    } catch (error) {
      console.error('Error fetching root data:', error);
    }
  };

  const handleIconClick1 = () => {
    if (!selectedYear) {
      setAlertMessage('Please select a year before proceeding.'); // Show alert message
      return; // Stop further execution if no year is selected
    }

    // Check if studentSerialNo has no entries
    if (!studentSerialNo || Object.keys(studentSerialNo).length === 0) {
      setAlertMessage('No matching students found.');
      return; // Exit the function if no students are found
    }

    // Proceed with navigation if students are found
    navigate('/rootpavati', {
      state: { amount1, studentSerialNo, fromtheway, thewayup, schoolDetails, allData, newrootdata, selectedYear }
    });


    // console.log("newrootdata",newrootdata);
    // console.log("allData",allData);
    // console.log("rootData",rootData);

  };

  const handleDriverChange = (e) => {
    const selectedDriverName = e.target.value;
    setDriver(selectedDriverName); // Update the selected driver

    // Find the selected driver info based on the driver name
    const selectedDriver = drivers.find(driver => driver.driverName === selectedDriverName);
    // console.log("selectedDriver",selectedDriver);

    setDriverInfo(selectedDriver || null); // Update driverInfo state
    // console.log(`Selected Driver: ${selectedDriverName}`); // Log the selected driver to console
  };

  const handleIconClick2 = async () => {
    try {
      // Ensure that driverInfo.roots is an array
      const rootsArray = driverInfo.roots;
      // console.log("rootsArray", rootsArray);

      const fetchPromises = rootsArray.map(root => {
        return axios.get(
          `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/root/${selectedYear}/${root}.json`
        );
      });

      const responses = await Promise.all(fetchPromises);

      const combinedRootData = responses.reduce((acc, response) => {
        const rootData = response.data;
        if (rootData && rootData.studentSerialNo) {
          acc.studentSerialNo = acc.studentSerialNo || {};
          Object.assign(acc.studentSerialNo, rootData.studentSerialNo);
        }
        return acc;
      }, { studentSerialNo: {} });

      // console.log("Combined Root Data", combinedRootData);

      // Check if combinedRootData or studentSerialNo is unavailable
      if (!combinedRootData || !combinedRootData.studentSerialNo) {
        setAlertMessage('Student is not available.');
        return;
      }

      // Check if studentSerialNo is an empty array or object
      if (Object.keys(combinedRootData.studentSerialNo).length === 0) {
        setAlertMessage('Student is not available.');
        return; // Stop navigation
      }

      // Pass the combined root data to the next page
      navigate('/driverpavati', { state: { driverInfo, schoolDetails, selectedYear, roots: rootsArray, combinedRootData } });

    } catch (error) {
      console.error('Error fetching root data:', error);
      setAlertMessage('An error occurred while fetching root data.');
    }
  };
  const handleGoBack = () => {
    navigate(-1); // Use navigate to go back
  };

  return (
    <>
      <div className='main-content-of-page'>
        <AlertMessage message={alertMessage} show={showAlert} />


        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '15px', marginLeft: '88px', width: '78%' }}>
          {loading && <img width={'110px'} className="registerLoading" src={loadingspinner} style={{ top: '48%', left: '52%', position: 'absolute' }} />}
          <button
            onClick={handleGoBack}
            style={{
              backgroundColor: '#FFFFFF',
              color: 'black',
              padding: '6px 18px',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              marginRight: '20px',
              border: '1px solid black',
            }}
          >
            <i className="fa fa-arrow-left" style={{ fontSize: '22px', marginRight: '8px' }}></i>
            Go Back
          </button>
          <div style={{ width: '150px' }}></div>
          <h3 className=" my-3" style={{ color: '#1B4332', fontWeight: '600', textAlign: 'center', flexGrow: 1, marginLeft: '-160px' }}>
            {language === "English" ? "Reports" : "रिपोर्ट"}
          </h3>
        </div>


        <center>
          <div style={formStyle}>

            <div style={{ ...rowInsideBoxStyle2, width: '100%', padding: '15px', border: '1px solid #131212', borderRadius: '8px', marginTop: '10px', display: 'flex', height: '60px' }}>
              <div style={rowInsideBoxStyle}>
                <label htmlFor="year" style={labelStyle1}>{language === "English" ? "Year:  " : "आर्थिक वर्ष "}</label>
                <select
                  id="year"
                  value={selectedYear}
                  onChange={handleYearChange}
                  required
                  style={selectStyle}
                >
                  <option value="">{language === "English" ? "Select Year:  " : "वर्ष निवडा "}</option>
                  {["2019-2020", "2020-2021", "2021-2022", "2022-2023", "2023-2024", "2024-2025", "2025-2026", "2026-2027", "2027-2028"].map((year) => (
                    <option key={year} value={year}>{year}</option>
                  ))}
                </select>
              </div>

              <div style={{ ...rowInsideBoxStyle, marginLeft: '5px' }}>
                <label htmlFor="currentClass" style={labelStyle}>{language === "English" ? "Class:  " : "वर्ग"}</label>
                <select
                  style={selectStyle}
                  id="currentClass"
                  value={selectedClass}
                  onChange={handleClassChange}
                >
                  <option value="">{language === "English" ? " Select Class " : "वर्ग निवडा "}</option>
                  {Array.isArray(classes) && sortClasses(classes.filter(cls => typeof cls === 'string' && cls.trim() !== ""), language).map((cls, index) => (
                    <option key={index} value={cls}>{cls}</option>
                  ))}
                  <option value="All">All</option>
                </select>
              </div>

              <div style={{ ...rowInsideBoxStyle, marginLeft: '5px' }}>
                <label htmlFor="division" style={{ color: '#4a235a', fontSize: '15px', fontWeight: 'bold' }}>
                  {language === "English" ? " Division: " : "तुकडी "}
                </label>
                <select
                  id="division"
                  value={selectedDivision}
                  onChange={handleDivisionChange}
                  style={selectStyle}
                >
                  <option value="">{language === "English" ? " Select Division: " : "तुकडी निवडा "}</option>
                  {Array.isArray(divisionOptions[selectedClass]) && divisionOptions[selectedClass].length > 0 ? (
                    divisionOptions[selectedClass].map((division, index) => (
                      <option key={index} value={division}>{division}</option>
                    ))
                  ) : (
                    <option disabled>{language === "English" ? "No Divisions Available" : "कोणत्याही तुकड्या उपलब्ध नाहीत"}</option>
                  )}
                  <option value="All">All</option>
                </select>

              </div>
              <div onClick={handlePdfClick} >
                <FaFileAlt style={{ ...iconStyle4, right: '3.2%' }} />
              </div>
            </div>


            {/* <div style={boxStyle1}> */}
            <div style={{ ...rowInsideBoxStyle2, width: '100%', padding: '15px', border: '1px solid #131212', borderRadius: '8px', marginTop: '10px', display: 'flex', height: '60px' }}>
              <label htmlFor='studentfee' style={labelStyle1}>{language === "English" ? " Student Fee: " : "विद्यार्थी फी "}</label>
              <select
                id='studentfee'
                style={{ ...selectStyle2, marginLeft: '12px' }}
                value={selectedFee} // Bind select value to state
                onChange={handleSelectChange} // Update state when the selection changes
              >
                <option value="">{language === "English" ? " Select: " : "निवडा "}</option> {/* Default option */}
                <option value="Fee Completed">Fee Completed</option>
                <option value="Fee Uncompleted">Fee Uncompleted</option>
                <option value="Fee Pending">Fee Pending (No Fee Paid Yet)</option>
              </select>
              <div onClick={handleIconClick}>
                <FaFileAlt style={{ ...iconStyle4, right: '3.2%' }} />
              </div>
            </div>
            {/* </div> */}

            <button type="button" onClick={handleReadMoreClick} style={{ marginLeft: "87%", color: 'White', border: '1px solid white', borderRadius: '5px', background: 'gray', padding: '5px', marginTop: '5px', width: '120px' }}>View More <i class="fa-solid fa-arrow-down"></i> </button>
            {readMoreVisible && (

              <div style={smallFormStyle}>
                <div style={boxStyle1}>
                  <div style={rowInsideBoxStyle2}>
                    <label htmlFor="currentClass" style={labelStyle1}>{language === "English" ? " Class: " : "वर्ग "}</label>
                    <select
                      style={{ ...selectStyle2, marginLeft: '-11px' }}
                      id="currentClass"
                      value={selectedClass}
                      onChange={handleClassChange}
                      required
                    >
                      <option value="">{language === "English" ? " Select Class " : "वर्ग निवडा "}</option>
                      {Array.isArray(classes) && sortClasses(classes.filter(cls => typeof cls === 'string' && cls.trim() !== ""), language).map((cls, index) => (
                        <option key={index} value={cls}>{cls}</option>
                      ))}
                      <option value="All">All</option>

                    </select>
                  </div>

                  <div style={rowInsideBoxStyle2}>
                    <label style={labelStyle1}>{language === "English" ? " Fee Type: " : "विद्यार्थी फी "}</label>
                    <select style={{ ...selectStyle2, marginLeft: '-11px' }} value={selectedFeeType} onChange={handleFeeTypeChange}>
                      <option value=""> {language === "English" ? " Select Fee " : "फी निवडा "}</option>
                      {filteredFeeTypes.length > 0 ? (
                        filteredFeeTypes.map((feeType, index) => (
                          <option key={index} value={feeType}>
                            {getBaseFeetype(feeType)}
                          </option>
                        ))
                      ) : (
                        <option disabled> {language === "English" ? " No Fee Types Available " : "कोणतेही शुल्क प्रकार उपलब्ध नाहीत "}</option>
                      )}
                    </select>
                    <div onClick={handlePavatino1Click} >
                      <FaFileAlt style={{ ...iconStyle4, right: '1.2%', top: '-50%' }} />
                    </div>

                  </div>

                </div>
                <div>
                  <div style={boxStyle}>
                    <label htmlFor="root" style={labelStyle1}>{language === "English" ? " Root:" : "मार्ग"}</label>
                    <select
                      style={selectStyle2}
                      id="root"
                      value={root}  // The selected root value
                      onChange={(e) => {
                        const selectedRootId = e.target.value;
                        setRoot(selectedRootId);
                        // console.log('Selected Root:', selectedRootId); 
                        fetchRootDetails(selectedRootId);
                      }}
                      required
                    >
                      <option value="">{language === "English" ? " Select Root:" : "मार्ग निवडा"}</option>
                      {roots.map((item) => (
                        <option key={item.id} value={item.id}>
                          {`${item.fromtheway} - ${item.thewayup}`}
                        </option>
                      ))}
                    </select>
                    <div onClick={handleIconClick1} >
                      <FaFileAlt style={iconStyle4} />
                    </div>
                  </div>

                </div>
                <div style={boxStyle}>
                  <label style={labelStyle1}>{language === "English" ? " Driver:" : "चालक:"}</label>
                  <select
                    id='driver'
                    value={driver}
                    onChange={handleDriverChange} // Update the selected driver
                    style={selectStyle2}
                  >
                    <option value="">{language === "English" ? " Select Driver:" : "चालक निवडा:"}</option>
                    {drivers.map((driverItem, index) => (
                      <option key={index} value={driverItem.driverName}>
                        {driverItem.driverName} {/* Display only the driver name */}
                      </option>
                    ))}
                  </select>
                  <div onClick={handleIconClick2} >
                    <FaFileAlt style={iconStyle4} />
                  </div>
                </div>
                {/* Add a wrapper with box styling */}
                <div style={boxStyle}>
                  <label style={labelStyle1}>{language === "English" ? " Date:" : "दिनांक:"}</label>
                  <input
                    type="date"
                    id="dateFrom"
                    value={dateFrom}
                    onChange={(e) => setDateFrom(e.target.value)} // Set the "From" date
                    style={{ marginLeft: '135px', width: '150px', borderRadius: '5px', border: '1px solid gray', padding: '4px' }}
                  />
                  <span style={{ marginRight: '15px', marginLeft: '15px', marginTop: '5px' }}>To</span>
                  <input
                    type="date"
                    id="dateTo"
                    value={dateTo}
                    onChange={(e) => setDateTo(e.target.value)} // Set the "To" date
                    style={{ marginRight: '18px', width: '150px', borderRadius: '5px', border: '1px solid gray', padding: '4px' }}
                  />

                  {/* Wrapping FaFileAlt in a div and adding onClick handler */}
                  <div onClick={handleYearPdfClick} >
                    <FaFileAlt style={iconStyle4} />
                  </div>
                </div>

              </div>
            )}
          </div>
        </center>
      </div>
    </>
  );
}

const boxStyle1 = {
  border: '1px solid #131212',
  borderRadius: '8px',
  padding: '12px',
  backgroundColor: '#f9f9f9',
  boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
  margin: '18px 0',
  width: '100%',
};

const labelStyle1 = {
  color: '#4a235a',
  fontSize: '16px',
  fontWeight: 'bold',
};
const selectStyle2 = {
  width: "200px",
  padding: "5px",
  height: '35px',
  fontSize: '14px',
  position: 'absolute',  // Use absolute positioning to move the select element
  left: '200px',
};

const labelStyle = {
  display: 'block',
  marginRight: '10px',
  fontWeight: 'bold',
  color: '#4a235a',
  fontSize: '15px',
}
const iconStyle4 = {
  fontSize: '45px',
  color: '#A31D27',
  right: '2%',
  position: 'absolute',
  top: '5px'
};


const formStyle = {
  border: '1px solid #131212',
  padding: '15px',
  borderRadius: '5px',
  width: '90%',
  maxHeight: '83vh',
  marginTop: '10px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  overflowY: 'auto',
  marginBottom: '50px'
};


const selectStyle = {
  width: '164px',
  padding: '8px',
  boxSizing: 'border-box',
  marginLeft: '1%',
  height: '35px',
  fontSize: '14px',
};

const rowInsideBoxStyle = {
  display: 'flex',
  alignItems: 'center',
  flexBasis: '20%',
};
const boxStyle = {
  width: '100%',
  padding: '23px 15px ',
  border: '1px solid #131212',
  borderRadius: '8px',
  marginTop: '10px',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'row',
  position: 'relative',
};
const rowInsideBoxStyle2 = {
  display: 'flex',
  alignItems: 'center',
  padding: '15px 0',
  width: '100%',
  marginBottom: '0px',
  position: 'relative',
};


const feeStyle = {
  padding: '15px',
  display: 'flex',
  width: '100%',
  paddingBottom: '0',
  position: 'relative',
};


const smallFormStyle = {
  border: '1px solid #131212',
  padding: '10px',
  marginTop: '10px',
  backgroundColor: '#f9f9f9',
  borderRadius: '5px',
  width: '100%',
  height: '47vh',
  overflowY: 'auto',
  paddingBottom: '10px'
};

export default Pavati;